import React from 'react';

const StepNavigation = ({ 
  currentStep, 
  totalSteps, 
  onPrev, 
  onNext, 
  onSubmit, 
  loading, 
  canProceed,
  onSkip,
  mode = 'create',
  onSaveAndExit
}) => {
  const isFirstStep = currentStep === 0;
  const isLastStep = currentStep === totalSteps - 1;

  return (
    <div className="border-t border-gray-200 bg-gray-50 p-4 sm:p-6 md:p-8">
      {/* Mobile Layout */}
      <div className="md:hidden space-y-3">
        {/* Step Counter */}
        <div className="text-center text-sm text-gray-500 font-medium">
          Step {currentStep + 1} of {totalSteps}
        </div>
        
        {/* All Buttons - Single Row Layout */}
        <div className="flex flex-wrap gap-2 justify-center">
          {/* Previous Button */}
          <button
            onClick={onPrev}
            disabled={isFirstStep || loading}
            className={`flex items-center justify-center px-3 py-2 rounded-lg font-medium text-xs transition-colors min-w-[70px] ${
              isFirstStep || loading
                ? 'text-gray-400 cursor-not-allowed bg-gray-100'
                : 'text-gray-600 hover:text-gray-800 bg-white border border-gray-300'
            }`}
          >
            ← Prev
          </button>
          
          {/* Skip Button */}
          {mode === 'create' && !isLastStep && currentStep > 0 && onSkip && (
            <button
              onClick={onSkip}
              className="flex items-center justify-center px-3 py-2 rounded-lg border border-orange-300 text-orange-600 hover:bg-orange-50 font-medium text-xs min-w-[60px]"
            >
              Skip
            </button>
          )}
          
          {/* Save & Exit */}
          {onSaveAndExit && (
            <button
              onClick={onSaveAndExit}
              className="flex items-center justify-center px-3 py-2 rounded-lg border border-green-300 text-green-600 hover:bg-green-50 font-medium text-xs min-w-[70px]"
            >
              Save
            </button>
          )}
          
          {/* Next/Submit Button */}
          {isLastStep ? (
            <button
              onClick={onSubmit}
              disabled={loading || !canProceed}
              className={`flex items-center justify-center px-3 py-2 rounded-lg font-medium text-xs transition-colors min-w-[80px] ${
                loading || !canProceed
                  ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                  : 'bg-blue-600 text-white hover:bg-blue-700'
              }`}
            >
              {loading ? 'Creating...' : 'Create'}
            </button>
          ) : (
            <button
              onClick={onNext}
              disabled={loading || !canProceed}
              className={`flex items-center justify-center px-3 py-2 rounded-lg font-medium text-xs transition-colors min-w-[70px] ${
                loading || !canProceed
                  ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                  : 'bg-blue-600 text-white hover:bg-blue-700'
              }`}
            >
              Next →
            </button>
          )}
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="hidden md:flex items-center justify-between">
        <div className="flex items-center space-x-3">
          {/* Previous Button */}
          <button
            onClick={onPrev}
            disabled={isFirstStep || loading}
            className={`flex items-center px-4 py-2 rounded-lg font-medium text-sm transition-colors ${
              isFirstStep || loading
                ? 'text-gray-400 cursor-not-allowed bg-gray-100'
                : 'text-gray-600 hover:text-gray-800 bg-white border border-gray-300'
            }`}
          >
            ← Previous
          </button>
          
          {/* Skip Button */}
          {mode === 'create' && !isLastStep && currentStep > 0 && onSkip && (
            <button
              onClick={onSkip}
              className="flex items-center px-4 py-2 rounded-lg border border-orange-300 text-orange-600 hover:bg-orange-50 font-medium text-sm"
            >
              Skip →
            </button>
          )}
          
          {/* Save & Exit */}
          {onSaveAndExit && (
            <button
              onClick={onSaveAndExit}
              className="flex items-center px-4 py-2 rounded-lg border border-green-300 text-green-600 hover:bg-green-50 font-medium text-sm"
            >
              Save & Exit
            </button>
          )}
        </div>

        {/* Step Counter */}
        <div className="text-sm text-gray-500 font-medium">
          Step {currentStep + 1} of {totalSteps}
        </div>

        {/* Next/Submit Button */}
        {isLastStep ? (
          <button
            onClick={onSubmit}
            disabled={loading || !canProceed}
            className={`flex items-center px-6 py-2 rounded-lg font-medium text-sm transition-colors ${
              loading || !canProceed
                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                : 'bg-blue-600 text-white hover:bg-blue-700'
            }`}
          >
            {loading ? 'Creating Company...' : 'Create Company'}
          </button>
        ) : (
          <button
            onClick={onNext}
            disabled={loading || !canProceed}
            className={`flex items-center px-6 py-2 rounded-lg font-medium text-sm transition-colors ${
              loading || !canProceed
                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                : 'bg-blue-600 text-white hover:bg-blue-700'
            }`}
          >
            Next →
          </button>
        )}
      </div>
    </div>
  );
};

export default StepNavigation;
